// Definindo os passos como enum para facilitar a escalabilidade
export enum PaymentStep {
  LOADING = "LOADING",
  PAYMENT = "PAYMENT",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  CRITERIA = "CRITERIA",
  ADDRESS = "ADDRESS"
}